import { SchedulingChangeRequestsRequest } from '../../../../models/employees-portal/CreateSchedulingRequest';
import { requests } from '../apiAgent';

export const EmployeesPortalAPI = {
    getAllSchedulings: (startDate: string, endDate: string) => {
        let body = { startDate: startDate, endDate: endDate };
        return requests
            .post(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/workshift-scheduling-and-interruptions-by-user',
                body
            )
            .then((response) => response);
    },

    PendingSchedulingRequest: () => {
        return requests
            .get(
                '/jerusalem/api/v2.0.0/scheduling-change-requests/pending-scheduling-change-requests-by-user'
            )
            .then((response) => response);
    },

    createSchedulingRequest: (model: SchedulingChangeRequestsRequest) => {
        return requests
            .post('/jerusalem/api/v2.0.0/scheduling-change-requests', model)
            .then((response) => response);
    },
};
